/* eslint-disable no-param-reassign */
import axios from 'axios'

const baseURL = process.env.VUE_APP_BASE_URL

export default {
   namespaced: true,
   state: {
      tahun: new Date().getFullYear(),
      refreshTimestamp: 0,
      statistik: {
         periode_1: { total: 0, jumlah: 0 },
         periode_2: { total: 0, jumlah: 0 },
      },
      umkChart: {
         data: [],
      },
      umkKbli: {
         data: [],
      },
      umkSektor: {
         data: [],
      },
      umkStatus: {
         data: [],
      },
   },
   actions: {
      triggerRefresh({ commit }) {
         commit('SET_REFRESH_TIMESTAMP', Date.now())
      },
      getStatistik({ commit, rootState, state }, tahun = state.tahun) {
         const selectedYear = tahun instanceof Date
            ? tahun.getFullYear()
            : Number(tahun) || new Date().getFullYear()

         commit('SET_TAHUN', selectedYear)
         rootState.isLoading = true
         return axios.get(`${baseURL}dashboard/lkpm/statistik`, {
            params: { year: selectedYear },
         }).then(
            response => {
               const data = response.data || {}
               commit('SET_STATISTIK', data.data || data || {})

               rootState.isLoading = false
               return data
            },
            () => {
               rootState.isLoading = false
            },
         )
      },
      getUmkChart({ commit, rootState, state }, tahun = state.tahun) {
         const selectedYear = tahun instanceof Date
            ? tahun.getFullYear()
            : Number(tahun) || new Date().getFullYear()

         rootState.isLoading = true
         return axios.get(`${baseURL}dashboard/lkpm/umk-chart`, {
            params: { year: selectedYear },
         }).then(
            response => {
               const data = response.data || {}
               commit('SET_UMK_CHART', data)

               rootState.isLoading = false
               return data
            },
            error => {
               rootState.isLoading = false
               return Promise.reject(error)
            },
         )
      },
      getUmkKbli({ commit, rootState, state }, tahun = state.tahun) {
         const selectedYear = tahun instanceof Date
            ? tahun.getFullYear()
            : Number(tahun) || new Date().getFullYear()

         rootState.isLoading = true
         return axios.get(`${baseURL}dashboard/lkpm/umk-kbli`, {
            params: { year: selectedYear },
         }).then(
            response => {
               const data = response.data || {}
               commit('SET_UMK_KBLI', data)

               rootState.isLoading = false
               return data
            },
            error => {
               rootState.isLoading = false
               return Promise.reject(error)
            },
         )
      },
      getUmkSektor({ commit, rootState, state }, tahun = state.tahun) {
         const selectedYear = tahun instanceof Date
            ? tahun.getFullYear()
            : Number(tahun) || new Date().getFullYear()

         rootState.isLoading = true
         return axios.get(`${baseURL}dashboard/lkpm/umk-sektor`, {
            params: { year: selectedYear },
         }).then(
            response => {
               const data = response.data || {}
               commit('SET_UMK_SEKTOR', data)

               rootState.isLoading = false
               return data
            },
            error => {
               rootState.isLoading = false
               return Promise.reject(error)
            },
         )
      },
      getUmkStatus({ commit, rootState, state }, tahun = state.tahun) {
         const selectedYear = tahun instanceof Date
            ? tahun.getFullYear()
            : Number(tahun) || new Date().getFullYear()

         rootState.isLoading = true
         return axios.get(`${baseURL}dashboard/lkpm/umk-status`, {
            params: { year: selectedYear },
         }).then(
            response => {
               const data = response.data || {}
               commit('SET_UMK_STATUS', data)

               rootState.isLoading = false
               return data
            },
            error => {
               rootState.isLoading = false
               return Promise.reject(error)
            },
         )
      },
   },
   mutations: {
      SET_TAHUN(state, tahun) {
         state.tahun = tahun
      },
      SET_REFRESH_TIMESTAMP(state, timestamp) {
         state.refreshTimestamp = timestamp
      },
      SET_STATISTIK(state, data) {
         const periode1 = data.periode_1 || data.periode1 || {}
         const periode2 = data.periode_2 || data.periode2 || {}

         state.statistik = {
            periode_1: {
               total: Number(periode1.total ?? periode1 ?? 0),
               jumlah: Number(periode1.jumlah ?? 0),
            },
            periode_2: {
               total: Number(periode2.total ?? periode2 ?? 0),
               jumlah: Number(periode2.jumlah ?? 0),
            },
         }
      },
      SET_UMK_CHART(state, data) {
         state.umkChart = {
            data: Array.isArray(data.data) ? data.data : [],
         }
      },
      SET_UMK_KBLI(state, data) {
         state.umkKbli = {
            data: Array.isArray(data.data) ? data.data : [],
         }
      },
      SET_UMK_SEKTOR(state, data) {
         state.umkSektor = {
            data: Array.isArray(data.data) ? data.data : [],
         }
      },
      SET_UMK_STATUS(state, data) {
         state.umkStatus = {
            data: Array.isArray(data.data) ? data.data : [],
         }
      },
   },
}
